export default "__VITE_ASSET__2ZUq6Z8s__"